
const sleep = (duration) => (...args) => new Promise(
  resolve => setTimeout(() => resolve(...args), duration)
);

const retryRequest = (data, limit = 10) => {
  const { canonical } = data;
  return fetch(canonical)
    .then(sleep(250))
    .then(resp => {
      if (!resp.ok && limit >= 0) {
        return retryRequest(data, --limit);
      }
      if (limit === 0) console.log('Timeout'); // TODO: Handle
      return data;
    })
    .catch((e) => {
      // TODO: Handle
      console.log('Error:', e);
    });
};

const uploadImage = ({
  authorization = null,
  api = null,
  defaultBlock = 'paragraph',
  sizes = [400, 800, 1200],
}) => (change, img, editor) => {
  const formData = new FormData();
  formData.append('img', img);
  formData.append('sizes', JSON.stringify(sizes));

  const tempState = change.insertBlock({
    type: 'loading-spinner',
    isVoid: true,
  });

  editor.onChange(tempState);

  return fetch(api, {
    method: 'POST',
    headers: {
      Authorization: authorization,
    },
    body: formData,
  })
    .then(response => response.json())
    .then(data => retryRequest(data))
    .then(data => change.undo().delete().insertBlock({
      type: 'image',
      isVoid: true,
      data,
    }).insertBlock(defaultBlock));
};

export default uploadImage;
